import { Button as MuiButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import type { ButtonProps } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  button: {
    padding: 0,
    fontWeight: 400,
    textDecoration: 'none',

    '& > svg, & > span': {
      color: theme.palette.text.disabled,
    },
  },
  icon: {
    fontSize: 18,
    marginRight: theme.spacing(1 / 2),
  },
}));

interface ToolbarBackButtonProps {
  readonly to?: string;
}

export const ToolbarBackButton: React.FC<ButtonProps & ToolbarBackButtonProps> = ({ ...restProps }) => {
  const { classes } = useStyles();

  return (
    <MuiButton
      variant="text"
      className={classes.button}
      {...restProps}
    >
      <ArrowBackIcon className={classes.icon} />

      <span>
        Back
      </span>
    </MuiButton>
  );
};
